// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsEnvelopes from '../../api/actionsEnvelopes';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useEnvelopesStore from '@/app/store/modules/envelopes';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Columns
import { columnsEnvelopes, columnsEnvelopesId } from './columnsDef/columnsEnvelopes';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import { ENVELOPES } from '../../api/apiUrls';

/**
 * @param root0
 * @param root0.customQuery
 * @param root0.singleSelection
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.organizationId
 * @param root0.pageActions
 * @param root0.filtersEventName
 *@returns {JSX} EnvelopesTable
 */
function EnvelopesTable({
    customQuery = {},
    singleSelection = false,
    rowsSelected = undefined,
    setRowsSelected = undefined,
    pageActions = undefined,
    filtersEventName
}) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchEnvelopes: refetchFromStore, storeRefetchEnvelopes, queryEnvelopes: queryStored, storeQueryEnvelopes } = useEnvelopesStore();

    // Constants
    const initialQuery = getInitialQuery(customQuery);
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsEnvelopes.getEnvelopes({ query }, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchEnvelopes(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    // Constants
    const allColumns = columnsEnvelopes({
        query,
        setQuery,
        queryStored,
        storeQueryEnvelopes,
        setLaunchRefetch,
        selectionMode,
        singleSelection,
        filtersEventName
    });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsEnvelopesId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryEnvelopes}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            singleSelection={singleSelection}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}

            pageActions={pageActions}
            exportProps={{
                permissions: [Permissions.EXPORT_REMOTE_DOWNLOADS.name],
                api: ENVELOPES.EXPORT
            }}
        />
    );
}

EnvelopesTable.propTypes = {
    customQuery: PropTypes.object,
    singleSelection: PropTypes.bool,
    rowsSelected: PropTypes.object,
    setRowsSelected: PropTypes.func,
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default EnvelopesTable;